var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReception(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5113 13.1764L18.5023 26.2857L22.2557 32H16H9.74436L13.4978 26.2857L3.48871 13.1764C5.96511 11.1177 11.5981 9.14288 16 9.14288C20.4019 9.14288 26.0349 11.1177 28.5113 13.1764Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9955 2.08914C10.9955 0.738667 11.9359 0 13.0402 0C14.675 0 16 1.93562 16 3.42857C16 1.93524 17.3249 0 18.9597 0C20.0999 0 21.0045 0.707048 21.0045 2.28571C21.0045 4.95848 18.4935 7.09562 15.5083 6.83581C12.9064 6.60914 10.9955 4.47695 10.9955 2.08914Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.342518 6.65868C-0.358949 5.46972 0.0852021 4.4122 1.05691 3.93334C2.49571 3.22477 4.66768 4.35391 5.44338 5.6682C4.66768 4.35391 4.82866 2.07582 6.26746 1.36725C7.27086 0.873153 8.43483 1.10325 9.25474 2.49296C10.6435 4.84572 9.54333 7.81525 6.78084 8.88039C4.37283 9.80877 1.58281 8.76039 0.342518 6.65868Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6575 6.65868C30.4172 8.76039 27.6272 9.80877 25.2192 8.88039C22.4567 7.81525 21.3565 4.84572 22.7453 2.49296C23.5652 1.10325 24.7288 0.873153 25.7326 1.36725C27.1714 2.07582 27.3324 4.35391 26.5567 5.6682C27.3324 4.35391 29.5043 3.22477 30.9431 3.93334C31.9148 4.4122 32.359 5.46972 31.6575 6.65868Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReception);
export default __webpack_public_path__ + "static/media/reception.89921100ed9c0f5fba4e9fe1a409ccf8.svg";
export { ForwardRef as ReactComponent };